/**
 * Where the mobile app can be downloaded.
 *
 * ✅ 19 OCT 2026: THE REAL LISTINGS ARE IN. Both stores approved the app on 16 Oct
 * and it is held for a launch event, so until the developer presses Release these
 * URLs open the store's own "not available" page; from that moment they open the
 * listing, with no deploy needed. The developer asked for exactly that.
 * The history below is why this file is the one switch.
 *
 * ⚠️ THE STORE LISTINGS DO NOT EXIST. `Docs/15` Q8: neither the Apple Developer
 * account nor the Google Play account has been created, so there is no listing
 * to link to. The two URLs that used to live in `lib/mockData.ts` were
 * placeholders — `id000000000` is not a shape an Apple id ever takes — and they
 * were rendered as live links on five pages. A visitor who tapped one landed on
 * a store 404 with no explanation, which is a worse outcome than a badge that
 * says the app is not out yet.
 *
 * So `href` is `null` and `AppStoreBadges` renders a non-interactive
 * "coming soon" chip instead of an anchor. THIS FILE IS THE ONE SWITCH: put the
 * real URLs in when Q8 is answered and every badge on the site becomes a link
 * again, the `/download` page's "not released" notice disappears by itself, and
 * nothing else changes.
 *
 * ⚠️ The badges are ALSO not brand-compliant yet, for a separate reason.
 * `AppStoreBadges` draws lucide's `Apple` (a piece of fruit) and `Play`
 * (a triangle). Apple and Google both publish their marks with mandatory
 * artwork, size and clear-space rules and forbid redrawing them, so the real
 * artwork is dropped in at the same time as the URLs.
 */

export type AppStoreListing = {
  id: 'ios' | 'android'
  /** Store names are proper nouns — the same in every locale, never translated. */
  name: string
  /** `null` until the listing exists. See the header. */
  href: string | null
}

export const appStoreListings: AppStoreListing[] = [
  // App Store Connect app id 6822433640. No storefront in the path, so Apple sends
  // each visitor to their own (the app is Norway-only).
  { id: 'ios', name: 'App Store', href: 'https://apps.apple.com/app/id6822433640' },
  { id: 'android', name: 'Google Play', href: 'https://play.google.com/store/apps/details?id=no.proffplassen.app' },
]

/**
 * True once at least one store listing is real. `/download` uses it to decide
 * whether to show its "not released yet" notice, so that notice cannot outlive
 * the thing it is explaining.
 */
export const appStoresAreLive: boolean = appStoreListings.some(
  (listing) => listing.href !== null,
)
